import moment from 'moment'

import type { DeliverySlot } from './types/order'

const roundTime = (_time: string) => {
  const time = moment(_time, 'HH:mm:ss')
  if (time.minute() > 30) {
    return time.endOf('hour').add(1, 'ms')
  }

  return time.startOf('hour')
}

const formatTime = (time: string) => roundTime(time).format('ha')

export const toTimeRange = (deliverySlot: DeliverySlot) =>
  `${formatTime(deliverySlot.get('deliveryStart'))} - ${formatTime(
    deliverySlot.get('deliveryEnd'),
  )}`

export const parseTimeRange = (deliveryStart: string, deliveryEnd: string) =>
  `${formatTime(deliveryStart)} - ${formatTime(deliveryEnd)}`

export const isAfterCutoff = () => moment().hours() >= 12

export const getDateOffset = (date: string) => {
  const now = moment()
  const then = moment(date)
  const offset = Math.ceil(then.diff(now, 'hours', true) / 24)
  const adjustedOffset = isAfterCutoff() ? offset - 1 : offset

  return adjustedOffset
}

export const formatDeliveryTime = (
  deliveryStartTime: string,
  deliveryEndTime: string,
  tempDate: string,
) =>
  `${moment(`${tempDate} ${deliveryStartTime}`).format('ha')} - ${moment(
    `${tempDate} ${deliveryEndTime}`,
  ).format('ha')} `
